/** Над SlidingChat (drawer ~99999999): диалоги, реакции, emoji, mentions. */
export const CHAT_FLOATING_Z_INDEX = 100_000_000

export const UI_CONSTANTS = {
  REACTION_PICKER: {
    HIDE_DELAY_MS: 200,
    TRIGGER_HIDE_DELAY_MS: 500,
    VIEWPORT_MARGIN: 8,
  },

  AVATAR: {
    MIN_INITIALS_LENGTH: 2,
    INITIALS_PLACEHOLDER: '·',
    MAX_FIRST_NAME_LENGTH: 15,
    MAX_LAST_NAME_LENGTH: 20,
    UNKNOWN_USER_INITIALS: '??',
    DEFAULT_SIZE: 40,
  },

  FILE: {
    PREVIEW_IMAGE_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
  },

  MESSAGE: {
    DEFAULT_LIMIT: 50,
    SCROLL_THRESHOLD: 100,
  },
} as const

export const MESSAGE_STYLES = {
  MINE: {
    backgroundColor: '#D3EEEF',
    color: '#000000',
  },
  DARK_THEME: {
    backgroundColor: '#242b35',
    color: '#ffffff',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  LIGHT_THEME: {
    backgroundColor: '#ffffff',
    color: '#000000',
  },
} as const
